import React from 'react';
import Services from '../components/Services';
import ContactForm from '../components/ContactForm';

export default function ServicesPage() {
  return (
    <div className="pt-24 lg:pt-32">
      <div className="bg-slate-900 py-16 mb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight mb-4">
            Vores <span className="text-sky-500">Services</span>
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Vi tilbyder et bredt udvalg af professionelle behandlinger til din bil, lige fra luksus håndvask til avanceret keramisk coating.
          </p>
        </div>
      </div>
      <Services />
      <ContactForm />
    </div>
  );
}
